export default __webpack_public_path__ + "static/media/PY.a4722eaf.ico";